export const styles = {
    blanksField : { 
        color: 'blue'
    }
}